module.exports = "/images/user.png?cd01cc965c4474d28d0e10e9f2354000";